import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { trackPageView, trackAppStoreClick } from "../lib/analytics";
import "../styles/site.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/c-styl/id6811129106";

const SCENES = [
  { label: "Closet", kicker: "01 — Your Closet", title: "The clothes you already own.", caption: "Build a searchable digital closet in minutes — every piece auto-tagged.", img: "/shots/raw_03_closet.png" },
  { label: "Style", kicker: "02 — Your Style", title: "Styled around you.", caption: "Your fit, your preferences, your colours — tuned to how you like to dress.", img: "/shots/raw_02_mix.png" },
  { label: "Today", kicker: "03 — Today's Outfit", title: "A look for today.", caption: "Weather-smart, head-to-toe, built from your own wardrobe each morning.", img: "/shots/raw_01_today.png" },
  { label: "Try-On", kicker: "04 — See It On You", title: "See yourself wearing it.", caption: "Visualize any outfit on your own body with AI before you wear it.", img: "/shots/raw_01_today.png" },
  { label: "Spotted", kicker: "05 — Spotted a Look", title: "See a look. Make it yours.", caption: "Upload a photo, identify the pieces, and try them on yourself.", img: "/shots/raw_02_mix.png" },
  { label: "Shop", kicker: "06 — Shop & Try", title: "Try it before you buy it.", caption: "Bring in anything you find online and preview it on you.", img: "/shots/raw_04_add.png" },
  { label: "Pro", kicker: "07 — C-STYL Pro", title: "Unlimited try-ons.", caption: "Three free virtual try-ons, then go Pro for unlimited.", logo: true },
  { label: "Get it", kicker: "08 — C-STYL", title: "Get dressed in seconds.", caption: "Your closet, finally working for you.", logo: true, cta: true },
];

const DURATION = 4200;

export default function Launch() {
  const [i, setI] = useState(0);

  useEffect(() => {
    document.title = "C-STYL — Launch Film";
    trackPageView();
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const t = setInterval(() => setI((p) => (p + 1) % SCENES.length), DURATION);
    return () => clearInterval(t);
  }, []);

  const s = SCENES[i];

  return (
    <div className="site">
      <div className="film" data-testid="launch-page">
        <div className="film-top">
          <Link to="/" className="film-brand" data-testid="film-brand">
            <img src="/logo.png" alt="C-STYL" /> <span>C-STYL</span>
          </Link>
          <Link to="/" className="film-exit" data-testid="film-exit">Back to site ×</Link>
        </div>

        <div className="film-stage">
          <div className="film-copy" key={"c" + i}>
            <span className="kicker">{s.kicker}</span>
            <h1 className="serif">{s.title}</h1>
            <p>{s.caption}</p>
            {s.cta && (
              <a className="btn" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" onClick={trackAppStoreClick} data-testid="film-get-app">
                Get the app
                <svg className="arw" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </a>
            )}
          </div>
          <div className="film-art" key={"a" + i}>
            {s.logo ? (
              <img className="logo-mark" src="/logo.png" alt="C-STYL" />
            ) : (
              <div className="phone"><img src={s.img} alt={s.title} /></div>
            )}
          </div>
        </div>

        <div className="film-board" data-testid="film-board">
          {SCENES.map((sc, idx) => (
            <button
              key={idx}
              className={"film-dot" + (idx === i ? " active" : "")}
              onClick={() => setI(idx)}
              data-testid={`scene-${idx}`}
              aria-label={sc.label}
            >
              <span className="track"><i key={idx === i ? "run" + i : "idle"} /></span>
              <span className="lbl">{sc.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
